var map = {
	"./apple2e": [
		2553,
		553
	],
	"./apple2e.ts": [
		2553,
		553
	],
	"./apple2enh": [
		5045,
		45
	],
	"./apple2enh.ts": [
		5045,
		45
	],
	"./apple2ex": [
		2875,
		875
	],
	"./apple2ex.ts": [
		2875,
		875
	],
	"./apple2j": [
		7156,
		156
	],
	"./apple2j.ts": [
		7156,
		156
	],
	"./fpbasic": [
		4094,
		94
	],
	"./fpbasic.ts": [
		4094,
		94
	],
	"./intbasic": [
		7089,
		89
	],
	"./intbasic.ts": [
		7089,
		89
	],
	"./original": [
		4663,
		663
	],
	"./original.ts": [
		4663,
		663
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6190;
module.exports = webpackAsyncContext;